import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TS1_REMINDER_NOTES_MAX_LENGTH } from "../ts1-form.factories";

export type Ts1ReminderNotesModalData = {
	value: string;
	title?: string;
	placeholder?: string;
	commentAiAssist?: boolean;
};

@Component({
	selector: "app-ts1-reminder-notes-modal",
	templateUrl: "./ts1-reminder-notes-modal.component.html",
	styleUrls: ["./ts1-reminder-notes-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1ReminderNotesModalComponent {
	readonly maxLength = TS1_REMINDER_NOTES_MAX_LENGTH;
	readonly placeholder: string;
	readonly commentAiAssist: boolean;
	remarkControl = new FormControl("", [Validators.maxLength(this.maxLength)]);

	constructor(
		private dialogRef: MatDialogRef<Ts1ReminderNotesModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: Ts1ReminderNotesModalData,
	) {
		this.placeholder = data?.placeholder || "Enter reminder notes template...";
		this.commentAiAssist = data?.commentAiAssist === true;
		this.remarkControl.setValue(data?.value ?? "");
	}

	usesCommentAiToolbar(): boolean {
		return this.commentAiAssist;
	}

	commentLengthLabel(length: number): string {
		return this.commentAiAssist ? `(${length})` : `(${length} / ${this.maxLength})`;
	}

	getCommentMaxLength(): number | null {
		return this.commentAiAssist ? null : this.maxLength;
	}

	cancel(): void {
		this.dialogRef.close(null);
	}

	save(): void {
		const trimmed = (this.remarkControl.value ?? "").toString().trim().toUpperCase().slice(0, this.maxLength);
		this.dialogRef.close(trimmed);
	}
}
